import { w3cwebsocket as WebSocket } from "websocket";
import { calculateHistogram, getApiExchangeNameFromMktSegId, getDecimalLocatorFromApiExchangeName, getDynamicParamsForToFixed, getDecryptLocalStorage, ReconnectSocket, getAppInfoData, isAppDisableClosePrice } from "../utils/global_functions";
import { BCAST_MSG_CODE, BEST5_INDEX, TL_INDEX, DECIMAL_LOCATOR, LOCAL_STORAGE_KEYS } from "../utils/global_variables";
import Zlib from './zlib';

import { store as globalReduxStore } from '../redux/store';
import { getWfhTouchlineLastTick, updateBestFiveObj, updateTouchlineObj, updateWfhBestFiveLastTick, updateWfhTouchlineLastTick } from "../redux/actions/wfh";

let objSocket;
let objGlobal = {};
objGlobal.Constants = {};
objGlobal.Constants.C_S_CHANNEL_INTERACTIVE = 'Interactive';
objGlobal.Constants.C_S_ON = 'ON';
objGlobal.Constants.C_S_CHAR0 = '\u0000';
objGlobal.Constants.C_S_CHAR2 = '\u0002';
let objSelfSocCom = {};
objSelfSocCom.SocketChannelId = 'Broadcast';
objSelfSocCom.CompressStatus = 'ON';

const objTouchlineData = {};
const objBestFiveData = {};
export let objTokenWiseTLSubscripionCounter = {};
let objTokenWiseB5SubscripionCounter = {};

let arrDefaultTouchLineData = new Array(Math.max(...Object.values(TL_INDEX))).fill(''); //as 27 columns displaying in Ag grid
let arrDefaultBestFiveData = new Array(Math.max(...Object.values(BEST5_INDEX))).fill(''); //as 52 columns in document


// function sendSubscriptionForPreviousScrips() {

//     if (Object.values(objTokenWiseTLSubscripionCounter)?.length) {
//         let arrReq = [];
//         for (let i = 0; i < Object.keys(objTokenWiseTLSubscripionCounter).length; i++) {
//             let key = Object.keys(objTokenWiseTLSubscripionCounter)[i];
//             if (objTokenWiseTLSubscripionCounter[key] > 0) {
//                 arrReq.push(key);
//             }
//         }

//         if (arrReq?.length) {
//             let arrTouchline = arrReq.map((ele) => {
//                 const [exchangeId, token] = ele.split('_');
//                 return { exchangeId, token };
//             });
//             sendTouchlineRequest(arrTouchline);
//         }
//     }


//     // if(Object.values(objTokenWiseB5SubscripionCounter)?.length){
//     //     let arrReq = []
//     //     for(let i = 0 ; i< Object.keys(objTokenWiseB5SubscripionCounter).length; i++){
//     //       let key = Object.keys(objTokenWiseB5SubscripionCounter)[i]
//     //        if(objTokenWiseB5SubscripionCounter[key] > 0){
//     //         arrReq.push(key)
//     //        }
//     //     }

//     //     if(arrReq?.length){
//     //         let arrTouchline = arrReq.map((ele)=>{
//     //             const [exchangeId,token] = ele.split('_')
//     //             return {exchangeId,token}
//     //          })       
//     //          sendTouchlineRequest(arrTouchline)
//     //     }
//     // }



// }




const objBuySell = {
    BUY: 1,
    SELL: 2,
};

let nMsgCount = 0;

function updateConnectionStatus() {
    let obj = new Date();
    let hr, min, sec;

    hr = obj.getHours().toString();
    min = obj.getMinutes().toString();
    sec = obj.getSeconds().toString();

    if (hr.length === 1) hr = '0' + hr;

    if (min.length === 1) min = '0' + min;

    if (sec.length === 1) sec = '0' + sec;

    // console.log(msg);
}

function updateServerReceivedMessage() {
    let obj = new Date();
    let hr, min, sec;

    hr = obj.getHours().toString();
    min = obj.getMinutes().toString();
    sec = obj.getSeconds().toString();

    if (hr.length === 1) hr = '0' + hr;

    if (min.length === 1) min = '0' + min;

    if (sec.length === 1) sec = '0' + sec;

    // let objTime = hr + ':' + min + ':' + sec

    if (nMsgCount === 100) {
        nMsgCount = 0;
    }
    // console.log("INFO->", msg);
    nMsgCount++;
}

let getReadyStateDesc = function (nReadyState) {
    if (nReadyState === 0) return '0 (Connection not yet established.)';
    else if (nReadyState === 1)
        return '1 (Websocket connection is established and ready for communication.)';
    else if (nReadyState === 2)
        return '2 (Connection going through closing handshake.)';
    else if (nReadyState === 3)
        return '3 (Connection has been closed or could not be opened.)';
};

let addHTTPHeader = function (strRequestPacket) {
    try {
        if (typeof ArrayBuffer === 'undefined') {
            if (
                objSelfSocCom.SocketChannelId !==
                objGlobal.Constants.C_S_CHANNEL_INTERACTIVE
            ) {
                let strHead = String.fromCharCode('2');
                let nLength = strRequestPacket.length;
                let nLenLength = nLength.toString().length;
                let strLengthString = '';
                for (let i = 0; i < 5 - nLenLength; i++) {
                    strLengthString += '0';
                }
                strLengthString += nLength.toString();
                strRequestPacket = strHead + strLengthString + strRequestPacket;
                return strRequestPacket;
            } else {
                let strHead = String.fromCharCode('2');
                strRequestPacket = strHead + strRequestPacket;
                return strRequestPacket;
            }
        } else {
            let strHead = String.fromCharCode('2');
            if (objSelfSocCom.CompressStatus === objGlobal.Constants.C_S_ON)
                strHead = String.fromCharCode('5');

            let i;
            let objData = new ArrayBuffer(strHead.length);
            let arrHeaderBytes = new Uint8Array(objData);

            for (i = 0; i < strHead.length; i += 1) {
                arrHeaderBytes[i] = strHead.charCodeAt(i);
            }
            let arrBaRequest;
            if (objSelfSocCom.CompressStatus === objGlobal.Constants.C_S_ON)
                arrBaRequest = handleCompressedData(strRequestPacket);
            else arrBaRequest = handleConvertToByteArray(strRequestPacket);

            let nLength = arrBaRequest.length;
            if (
                objSelfSocCom.SocketChannelId !==
                objGlobal.Constants.C_S_CHANNEL_INTERACTIVE
            )
                nLength += 4;
            let nLenLength = nLength.toString().length;
            let strLengthString = '';

            for (i = 0; i < 5 - nLenLength; i++) {
                strLengthString += '0';
            }

            strLengthString += nLength.toString();

            objData = new ArrayBuffer(strLengthString.length);
            let arrLenBytes = new Uint8Array(objData);

            for (i = 0; i < strLengthString.length; i += 1) {
                arrLenBytes[i] = strLengthString.charCodeAt(i);
            }

            let arrBaActualSend = new Uint8Array(5 + nLength);
            arrBaActualSend.set(arrLenBytes);
            arrBaActualSend.set(arrBaRequest, 5);

            let arrOutputStream = new Uint8Array(
                arrHeaderBytes.length + arrBaActualSend.length,
            );
            arrOutputStream.set(arrHeaderBytes);
            arrOutputStream.set(arrBaActualSend, 1);
            return arrOutputStream.buffer;
        }
    } catch (e) { }
};

let handleCompressedData = function (strRawData) {
    try {
        let objData = new ArrayBuffer(strRawData.length);
        let arrUint8buf = new Uint8Array(objData);
        for (let i = 0; i < strRawData.length; i += 1) {
            arrUint8buf[i] = strRawData.charCodeAt(i) & 0xff;
        }
        let arrCompData = Zlib.compress(new Uint8Array(objData), 6);
        return arrCompData;
    } catch (e) {
        //console.log("handleCompressedData", e);
    }
};

let handleConvertToByteArray = function (strData) {
    try {
        let objArrbufData = new ArrayBuffer(strData.length);
        let arrUint8buf = new Uint8Array(objArrbufData);
        for (let i = 0; i < strData.length; i += 1) {
            arrUint8buf[i] = strData.charCodeAt(i) & 0xff;
        }
        let arrBaData = new Uint8Array(objArrbufData);
        return arrBaData;
    } catch (e) {
        //console.log("handleConvertToByteArray", e);
    }
};

let appendOrCopyBuffer = function (buffer1, buffer2) {
    let arrTmp = new Uint8Array(buffer1.byteLength + buffer2.byteLength);
    arrTmp.set(new Uint8Array(buffer1), 0);
    arrTmp.set(new Uint8Array(buffer2), buffer1.byteLength);
    return arrTmp;
};

let processPacketString = function (objData) {
    updateServerReceivedMessage('Data From Server : ' + objData);
    convertResponseIntoJsonArray(objData); //AbhiVaradkar

};

function convertResponseIntoJsonArray(strData) {
    try {
        let arrPipeSplitedData = strData.split('|');

        let objHeaderElement = arrPipeSplitedData.find(
            (element) => parseInt(element.split('=')[0]) === BCAST_MSG_CODE.MSG_CODE,
        );
        let nMsgCode = parseInt(objHeaderElement.split('=')[1]);

        switch (nMsgCode) {
            case BCAST_MSG_CODE.TOUCH_LINE: {
                //MultitouchLine
                convertTouchlineResponse(JSON.parse(JSON.stringify(arrPipeSplitedData)));
                break;
            }
            case BCAST_MSG_CODE.BEST_FIVE: {
                //BestFive

                convertBestFiveResponse(JSON.parse(JSON.stringify(arrPipeSplitedData)));
                break;
            }
            default: {
                break;
            }
        }
    } catch (err) {
        // console.log(err);
    }
}

const convertTouchlineResponse = (arrPipeSplitedData) => {

    try {
        let arrTouchLineData = arrDefaultTouchLineData.fill(''); //as 25 columns required in array
        let nDecimalLocator = DECIMAL_LOCATOR.NORMAL; //By HiralK : 09-08-2023 for price optimization
        let nDecimalLocatorLength = 2;
        arrPipeSplitedData.forEach((element) => {
            let objTouchline = element.split('=');
            switch (parseInt(objTouchline[0])) {
                case BCAST_MSG_CODE.SEGMENT_ID: {
                    arrTouchLineData[TL_INDEX.SEGMENT_ID] = parseInt(objTouchline[1]);
                    arrTouchLineData[TL_INDEX.EXCHANGE] = getApiExchangeNameFromMktSegId(arrTouchLineData[TL_INDEX.SEGMENT_ID]);
                    nDecimalLocator = getDecimalLocatorFromApiExchangeName(arrTouchLineData[TL_INDEX.EXCHANGE]); //By HiralK : 09-08-2023 for price optimization
                    nDecimalLocatorLength = getDynamicParamsForToFixed(arrTouchLineData[TL_INDEX.EXCHANGE]);
                    break;
                }
                case BCAST_MSG_CODE.SECURITY_CODE: {
                    arrTouchLineData[TL_INDEX.TOKEN] = parseInt(objTouchline[1]);
                    break;
                }
                case BCAST_MSG_CODE.BUY_QTY: {
                    arrTouchLineData[TL_INDEX.BUY_QTY] = parseInt(objTouchline[1]);
                    break;
                }
                case BCAST_MSG_CODE.SELL_QTY: {
                    arrTouchLineData[TL_INDEX.SELL_QTY] = parseInt(objTouchline[1]);
                    break;
                }
                case BCAST_MSG_CODE.BUY_PRICE: {
                    //const strBCastBuyPrice = parseFloat(objTouchline[1]);
                    //arrTouchLineData[TL_INDEX.BUY_PRICE] = parseFloat(strBCastBuyPrice);
                    arrTouchLineData[TL_INDEX.BUY_PRICE] = parseFloat(objTouchline[1]) / nDecimalLocator;//By HiralK : 09-08-2023 for price optimization
                    const lstrMapKey = arrTouchLineData[0] + '_' + arrTouchLineData[1];
                    const arrLastTick = objTouchlineData[lstrMapKey];
                    if (undefined !== arrLastTick) {
                        if (arrTouchLineData[TL_INDEX.BUY_PRICE] > arrLastTick[TL_INDEX.BUY_PRICE]) {
                            arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR] = 'U';
                        } else if (arrTouchLineData[TL_INDEX.BUY_PRICE] < arrLastTick[TL_INDEX.BUY_PRICE]) {
                            arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR] = 'D';
                        } else {
                            arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR] = 'S';
                        }
                    } else {
                        arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR] = 'S';
                    }

                    arrTouchLineData[TL_INDEX.BUY_PRICE] = arrTouchLineData[TL_INDEX.BUY_PRICE].toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.SELL_PRICE: {
                    //const strBCastSellPrice = objTouchline[1];
                    //arrTouchLineData[TL_INDEX.SELL_PRICE] = strBCastSellPrice;
                    arrTouchLineData[TL_INDEX.SELL_PRICE] = parseFloat(objTouchline[1]) / nDecimalLocator; //By HiralK : 09-08-2023 for price optimization
                    const lstrMapKey = arrTouchLineData[0] + '_' + arrTouchLineData[1];
                    const arrLastTick = objTouchlineData[lstrMapKey];
                    if (undefined !== arrLastTick) {
                        if (arrTouchLineData[TL_INDEX.SELL_PRICE] > arrLastTick[TL_INDEX.SELL_PRICE]) {
                            arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR] = 'U';
                        } else if (arrTouchLineData[TL_INDEX.SELL_PRICE] < arrLastTick[TL_INDEX.SELL_PRICE]) {
                            arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR] = 'D';
                        } else {
                            arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR] = 'S';
                        }
                    } else {
                        arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR] = 'S';
                    }
                    arrTouchLineData[TL_INDEX.SELL_PRICE] = arrTouchLineData[TL_INDEX.SELL_PRICE].toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.LAST_TRADE_PRICE: {
                    //const nLTP = objTouchline[1];
                    arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE] = parseFloat(objTouchline[1]) / nDecimalLocator; //By HiralK : 09-08-2023 for price optimization
                    let lstrMapKey = arrTouchLineData[0] + '_' + arrTouchLineData[1];
                    const arrLastTick = objTouchlineData[lstrMapKey];
                    if (undefined !== arrLastTick) {
                        if (arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE] > arrLastTick[TL_INDEX.LAST_TRADE_PRICE]) {
                            arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] = 'U';
                        } else if (arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE] < arrLastTick[TL_INDEX.LAST_TRADE_PRICE]) {
                            arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] = 'D';
                        } else {
                            arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] = 'S';
                        }
                    } else {
                        arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] = 'S';
                    }
                    arrTouchLineData[TL_INDEX.REAL_LAST_TRADE_PRICE] = parseFloat(objTouchline[1]) / nDecimalLocator;
                    arrTouchLineData[TL_INDEX.REAL_LAST_TRADE_PRICE] = arrTouchLineData[TL_INDEX.REAL_LAST_TRADE_PRICE].toFixed(nDecimalLocatorLength);
                    arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE] = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE].toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.LAST_TRADE_QTY: {
                    arrTouchLineData[TL_INDEX.LAST_TRADE_QTY] = parseInt(objTouchline[1]);
                    break;
                }
                case BCAST_MSG_CODE.LAST_TRADE_TIME: {
                    let arrSplitedDateTime = objTouchline[1].split(' ');
                    let strTime = arrSplitedDateTime[1].replace(/(..)/g, '$1:').slice(0, -1);
                    arrTouchLineData[TL_INDEX.LAST_TRADE_TIME] = arrSplitedDateTime[0] + ' ' + strTime; //objTouchline[1];
                    break;
                }
                case BCAST_MSG_CODE.LAST_UPDATE_TIME: {
                    let arrSplitedDateTime = objTouchline[1].split(' ');
                    let strTime = arrSplitedDateTime[1].replace(/(..)/g, '$1:').slice(0, -1);
                    arrTouchLineData[TL_INDEX.LAST_UPDATED_TIME] = arrSplitedDateTime[0] + ' ' + strTime;
                    break;
                }
                case BCAST_MSG_CODE.OPEN_INTEREST: {
                    arrTouchLineData[TL_INDEX.OPEN_INTEREST] = parseInt(objTouchline[1]);
                    break;
                }
                case BCAST_MSG_CODE.OPEN_INTEREST_PERCENT: {
                    arrTouchLineData[TL_INDEX.OPEN_INTEREST_PERCENT] = parseInt(objTouchline[1]);
                    break;
                }

                // case BCAST_MSG_CODE.NET_CHANGE_FROM_PRE_CLOSE: {
                // arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = objTouchline[1];
                // let lstrMapKey = arrTouchLineData[0] + '_' + arrTouchLineData[1];
                // const arrLastTick = objTouchlineData[lstrMapKey];
                // if (undefined !== arrLastTick) {
                //     if (parseFloat(objTouchline[1]) > parseFloat(arrLastTick[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE])) {
                //         arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] =
                //             'U'; //netChangeIndicator
                //     } else if (
                //         parseFloat(objTouchline[1]) < parseFloat(arrLastTick[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE])
                //     ) {
                //         arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] =
                //             'D'; //netChangeIndicator
                //     } else {
                //         arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] =
                //             'S'; //netChangeIndicator
                //     }
                // } else {
                //     arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] = 'S';
                // }
                // break;
                // }
                case BCAST_MSG_CODE.CLOSE_PRICE: {
                    arrTouchLineData[TL_INDEX.CLOSE_PRICE] = (parseFloat(objTouchline[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.OPEN_PRICE: {
                    arrTouchLineData[TL_INDEX.OPEN_PRICE] = (parseFloat(objTouchline[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.HIGH_PRICE: {
                    arrTouchLineData[TL_INDEX.HIGH_PRICE] = (parseFloat(objTouchline[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.LOW_PRICE: {
                    arrTouchLineData[TL_INDEX.LOW_PRICE] = (parseFloat(objTouchline[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.VOLUME: {
                    arrTouchLineData[TL_INDEX.VOLUME] = parseInt(objTouchline[1]); //as totalQtyTraded
                    break;
                }
                case BCAST_MSG_CODE.AVG_TRADED_PRICE: {
                    arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE] = (parseFloat(objTouchline[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.TOTAL_BUY_QTY: {
                    arrTouchLineData[TL_INDEX.TOTAL_BUY_QTY] = parseInt(objTouchline[1]);
                    break;
                }
                case BCAST_MSG_CODE.TOTAL_SELL_QTY: {
                    arrTouchLineData[TL_INDEX.TOTAL_SELL_QTY] = parseInt(objTouchline[1]);
                    break;
                }
                case BCAST_MSG_CODE.LIFE_TIME_HIGH: {
                    arrTouchLineData[TL_INDEX.LIFE_TIME_HIGH] = (parseFloat(objTouchline[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.LIFE_TIME_LOW: {
                    arrTouchLineData[TL_INDEX.LIFE_TIME_LOW] = (parseFloat(objTouchline[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                    break;
                }
                case BCAST_MSG_CODE.MARKET_TYPE: {
                    arrTouchLineData[TL_INDEX.MARKET_TYPE] =
                        objTouchline[1];
                    break;
                }
                case BCAST_MSG_CODE.TRADE_EXECUTION_RANGE: {
                    arrTouchLineData[TL_INDEX.TRADE_EXECUTION_RANGE] = objTouchline[1];
                    break;
                }
                case BCAST_MSG_CODE.DAILY_PRICE_RANGE: {
                    arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE] = objTouchline[1];
                    break;
                }
                //Ameersha N : 19-04-2023 - Breeze - APP-DISABLE-CLOSE-PRICE :: FROM TOUCHLINE DATA --Start
                case BCAST_MSG_CODE?.APP_DISABLE_CLOSE_PRICE: {
                    arrTouchLineData[TL_INDEX.APP_DISABLE_CLOSE_PRICE] = objTouchline[1];
                    let isAppDisableClosePriceOnOrOff = isAppDisableClosePrice();
                    if (isAppDisableClosePriceOnOrOff === 'ON' && parseFloat(objTouchline[1]) > 0) {
                        arrTouchLineData[TL_INDEX.CLOSE_PRICE] = (parseFloat(objTouchline[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
                    } else { }
                    break;
                }
                //Ameersha N : 19-04-2023 - Breeze - APP-DISABLE-CLOSE-PRICE :: FROM TOUCHLINE DATA --End
                default: {
                    break;
                }
            }
        });
        //Vaibhav Singh: 28-02-24: Added ClosePrice as Implemented In Wave2.0
        if (parseFloat(arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]) === 0) {
            arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE] = arrTouchLineData[TL_INDEX.CLOSE_PRICE];
        }

        //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
        if (parseFloat(arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]) - parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE]) > 0) {
            var strAbsNetChange = '+' + (parseFloat(arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]) - parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE])).toFixed(nDecimalLocatorLength);
        } else {
            strAbsNetChange = (parseFloat(arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]) - parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE])).toFixed(nDecimalLocatorLength);
        }
        arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = strAbsNetChange;
        //Ameersha N : 19-04-2023 - Breeze - APP-DISABLE-CLOSE-PRICE :: FROM TOUCHLINE DATA --Start
        const netChange = parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE]) !== 0 ? (parseFloat(strAbsNetChange) / parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE])) * 100 : 0;

        arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = netChange?.toFixed(2) > 0 ? ('+' + netChange?.toFixed(2)) : netChange?.toFixed(2);
        //Ameersha N : 19-04-2023 - Breeze - APP-DISABLE-CLOSE-PRICE :: FROM TOUCHLINE DATA --End

        //Ameersha N : 27-4-2024 -BREEZE -OPTION CHAIN CHANGES -- Start
        if (parseFloat(arrTouchLineData[TL_INDEX.REAL_LAST_TRADE_PRICE]) - parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE]) > 0) {
            var opstrAbsNetChange = '+' + (parseFloat(arrTouchLineData[TL_INDEX.REAL_LAST_TRADE_PRICE]) - parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE])).toFixed(nDecimalLocatorLength);
        } else {
            opstrAbsNetChange = (parseFloat(arrTouchLineData[TL_INDEX.REAL_LAST_TRADE_PRICE]) - parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE])).toFixed(nDecimalLocatorLength);
        }
        arrTouchLineData[TL_INDEX.REAL_ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = opstrAbsNetChange;

        const opnetChange = parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE]) !== 0 ? (parseFloat(opstrAbsNetChange) / parseFloat(arrTouchLineData[TL_INDEX.CLOSE_PRICE])) * 100 : 0;

        arrTouchLineData[TL_INDEX.REAL_NET_CHANGE_FROM_PRE_CLOSE] = opnetChange?.toFixed(2) > 0 ? ('+' + opnetChange?.toFixed(2)) : opnetChange?.toFixed(2);
        //Ameersha N : 27-4-2024 -BREEZE -OPTION CHAIN CHANGES -- Start

        //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
        const lstrMapKey = arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN];
        objTouchlineData[lstrMapKey] = JSON.parse(JSON.stringify(arrTouchLineData));

        globalReduxStore.dispatch(updateWfhTouchlineLastTick(objTouchlineData));

        const touchlineEvent = new CustomEvent("touchline", { detail: arrTouchLineData, bubbles: true });
        document.dispatchEvent(touchlineEvent);

    } catch (err) {
        // console.log('Error_touchline', err.message);
    }
};

function handleBestFiveTouchline(arrBestFiveData) {
    let arrTouchLineData = arrDefaultTouchLineData.fill('');
    if (objTokenWiseTLSubscripionCounter[arrBestFiveData[BEST5_INDEX.SEGMENT_ID] + '_' + arrBestFiveData[BEST5_INDEX.TOKEN]]) {
        let objLastTickData=globalReduxStore.dispatch(getWfhTouchlineLastTick())
        let arrLastickData=objLastTickData[arrBestFiveData[BEST5_INDEX.SEGMENT_ID] + '_' + arrBestFiveData[BEST5_INDEX.TOKEN]];
        arrTouchLineData[TL_INDEX.SEGMENT_ID] = arrBestFiveData[BEST5_INDEX.SEGMENT_ID];
        arrTouchLineData[TL_INDEX.TOKEN] = arrBestFiveData[BEST5_INDEX.TOKEN];
        arrTouchLineData[TL_INDEX.LAST_UPDATED_TIME] = arrBestFiveData[BEST5_INDEX.LAST_UPDATED_TIME];
        arrTouchLineData[TL_INDEX.LAST_TRADE_TIME] = arrBestFiveData[BEST5_INDEX.LAST_TRADE_TIME];
        arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE] = arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE];
        arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR] = arrBestFiveData[BEST5_INDEX.NET_CHANGE_INDICATOR];
        arrTouchLineData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = arrBestFiveData[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE];
        arrTouchLineData[TL_INDEX.LAST_TRADE_QTY] = arrBestFiveData[BEST5_INDEX.LAST_TRADE_QTY];
        arrTouchLineData[TL_INDEX.VOLUME] = arrBestFiveData[BEST5_INDEX.VOLUME];
        arrTouchLineData[TL_INDEX.AVG_TRADED_PRICE] = arrBestFiveData[BEST5_INDEX.AVG_TRADED_PRICE];
        arrTouchLineData[TL_INDEX.BUY_QTY] = arrBestFiveData[BEST5_INDEX.BUY_QTY_1];
        arrTouchLineData[TL_INDEX.BUY_PRICE] = arrBestFiveData[BEST5_INDEX.BUY_PRICE_1];
        arrTouchLineData[TL_INDEX.SELL_QTY] = arrBestFiveData[BEST5_INDEX.SELL_QTY_1];
        arrTouchLineData[TL_INDEX.SELL_PRICE] = arrBestFiveData[BEST5_INDEX.SELL_PRICE_1];
        arrTouchLineData[TL_INDEX.TOTAL_BUY_QTY] = arrBestFiveData[BEST5_INDEX.TOTAL_BUY_QTY];
        arrTouchLineData[TL_INDEX.TOTAL_SELL_QTY] = arrBestFiveData[BEST5_INDEX.TOTAL_SELL_QTY];
        arrTouchLineData[TL_INDEX.CLOSE_PRICE] = arrBestFiveData[BEST5_INDEX.CLOSE_PRICE];
        arrTouchLineData[TL_INDEX.OPEN_PRICE] = arrBestFiveData[BEST5_INDEX.OPEN_PRICE];
        arrTouchLineData[TL_INDEX.HIGH_PRICE] = arrBestFiveData[BEST5_INDEX.HIGH_PRICE];
        arrTouchLineData[TL_INDEX.LOW_PRICE] = arrBestFiveData[BEST5_INDEX.LOW_PRICE];
        arrTouchLineData[TL_INDEX.OPEN_INTEREST] = arrBestFiveData[BEST5_INDEX.OPEN_INTEREST];
        arrTouchLineData[TL_INDEX.LIFE_TIME_HIGH] = arrBestFiveData[BEST5_INDEX.LIFE_TIME_HIGH];
        arrTouchLineData[TL_INDEX.LIFE_TIME_LOW] = arrBestFiveData[BEST5_INDEX.LIFE_TIME_LOW];
        arrTouchLineData[TL_INDEX.MARKET_TYPE] = arrBestFiveData[BEST5_INDEX.MARKET_TYPE];
        arrTouchLineData[TL_INDEX.EXCHANGE] = arrBestFiveData[BEST5_INDEX.EXCHANGE];
        arrTouchLineData[TL_INDEX.DAILY_PRICE_RANGE] = arrBestFiveData[BEST5_INDEX.DAILY_PRICE_RANGE];
        arrTouchLineData[TL_INDEX.BUY_PRICE_INDICATOR] = arrBestFiveData[BEST5_INDEX.BUY_PRICE_INDICATOR];
        arrTouchLineData[TL_INDEX.SELL_PRICE_INDICATOR] = arrBestFiveData[BEST5_INDEX.SELL_PRICE_INDICATOR];
        arrTouchLineData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = arrBestFiveData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE];
        arrTouchLineData[TL_INDEX.OPEN_INTEREST_PERCENT] = arrBestFiveData[BEST5_INDEX.OPEN_INTEREST_PERCENT];
        arrTouchLineData[TL_INDEX.APP_DISABLE_CLOSE_PRICE] = arrBestFiveData[BEST5_INDEX.APP_DISABLE_CLOSE_PRICE];
        arrTouchLineData[TL_INDEX.REAL_LAST_TRADE_PRICE] = arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE];
        arrTouchLineData[TL_INDEX.REAL_ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = arrLastickData[TL_INDEX.REAL_ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] ?? '0.00';
        arrTouchLineData[TL_INDEX.REAL_NET_CHANGE_FROM_PRE_CLOSE] = arrLastickData[TL_INDEX.REAL_NET_CHANGE_FROM_PRE_CLOSE] ?? '0.00';
        arrTouchLineData[TL_INDEX.TRADE_EXECUTION_RANGE] = arrLastickData[TL_INDEX.TRADE_EXECUTION_RANGE] ?? '0.00 - 0.00';
        const touchlineEvent = new CustomEvent("touchline", { detail: arrTouchLineData, bubbles: true });
        document.dispatchEvent(touchlineEvent);
    }
}

function convertBestFiveResponse(arrPipeSplitedData) {
    try {
        let arrBestFiveData = arrDefaultBestFiveData.fill('');
        let objBestFiveBuy;
        let objBestFiveSell;
        let nBuySellFlag = 0; //1=Buy, 2=Sell
        let arrBuySellIndex = BEST5_INDEX.BUY_QTY_1; //10; //as best five data start from this index
        let nDecimalLocator = DECIMAL_LOCATOR.NORMAL; //By HiralK : 09-08-2023 for price optimization
        let nDecimalLocatorLength = 2;
        arrPipeSplitedData.forEach((element) => {
            let objBestFive;
            if (element.includes('$')) {
                if (objBuySell.BUY === nBuySellFlag) {
                    objBestFiveBuy = element.split('$');
                    objBestFiveBuy.forEach((buyData) => {
                        arrBestFiveData[arrBuySellIndex] = buyData.split('=')[1];
                        arrBuySellIndex++;
                    });
                } else if (objBuySell.SELL === nBuySellFlag) {
                    objBestFiveSell = element.split('$');
                    objBestFiveSell.forEach((sellData) => {
                        arrBestFiveData[arrBuySellIndex] = sellData.split('=')[1];
                        arrBuySellIndex++;
                    });
                }
            } else {
                objBestFive = element.split('=');
                if (BCAST_MSG_CODE.BUY_SELL === parseInt(objBestFive[0])) {
                    nBuySellFlag = parseInt(objBestFive[1]);
                } else {
                    nBuySellFlag = 0;
                }
            }
            if (undefined !== objBestFive && '' !== objBestFive && objBestFive.length > 1) {
                switch (parseInt(objBestFive[0])) {
                    case BCAST_MSG_CODE.SEGMENT_ID: {
                        arrBestFiveData[BEST5_INDEX.SEGMENT_ID] = parseInt(objBestFive[1]);
                        arrBestFiveData[BEST5_INDEX.EXCHANGE] = getApiExchangeNameFromMktSegId(arrBestFiveData[BEST5_INDEX.SEGMENT_ID]);
                        nDecimalLocator = getDecimalLocatorFromApiExchangeName(arrBestFiveData[BEST5_INDEX.EXCHANGE]); //By HiralK : 09-08-2023 for price optimization
                        nDecimalLocatorLength = getDynamicParamsForToFixed(arrBestFiveData[BEST5_INDEX.EXCHANGE]);
                        break;
                    }
                    case BCAST_MSG_CODE.SECURITY_CODE: {
                        arrBestFiveData[BEST5_INDEX.TOKEN] = parseInt(objBestFive[1]);
                        break;
                    }
                    case BCAST_MSG_CODE.LAST_TRADE_PRICE: {
                        //const nLTP = objBestFive[1];
                        arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE] = parseFloat(objBestFive[1]) / nDecimalLocator; //By HiralK : 09-08-2023 for price optimization
                        let lstrMapKey = arrBestFiveData[BEST5_INDEX.SEGMENT_ID] + '_' + arrBestFiveData[BEST5_INDEX.TOKEN];
                        const arrLastTick = objBestFiveData[lstrMapKey];
                        if (undefined !== arrLastTick) {
                            if (arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE] > arrLastTick[BEST5_INDEX.LAST_TRADE_PRICE]) {
                                arrBestFiveData[BEST5_INDEX.NET_CHANGE_INDICATOR] = 'U';
                            } else if (arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE] < arrLastTick[BEST5_INDEX.LAST_TRADE_PRICE]) {
                                arrBestFiveData[BEST5_INDEX.NET_CHANGE_INDICATOR] = 'D';
                            } else {
                                arrBestFiveData[BEST5_INDEX.NET_CHANGE_INDICATOR] = 'S';
                            }
                        } else {
                            arrBestFiveData[BEST5_INDEX.NET_CHANGE_INDICATOR] = 'S';
                        }
                        arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE] = arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE].toFixed(nDecimalLocatorLength);//By HiralK : 09-08-2023 for price optimization
                        break;
                    }
                    case BCAST_MSG_CODE.LAST_TRADE_QTY: {
                        arrBestFiveData[BEST5_INDEX.LAST_TRADE_QTY] = parseInt(objBestFive[1]);
                        break;
                    }
                    case BCAST_MSG_CODE.LAST_TRADE_TIME: {
                        let arrSplitedDateTime = objBestFive[1].split(' ');
                        let strTime = arrSplitedDateTime[1].replace(/(..)/g, '$1:').slice(0, -1);
                        arrBestFiveData[BEST5_INDEX.LAST_TRADE_TIME] = arrSplitedDateTime[0] + ' ' + strTime;
                        break;
                    }
                    case BCAST_MSG_CODE.LAST_UPDATE_TIME: {
                        let arrSplitedDateTime = objBestFive[1].split(' ');
                        let strTime = arrSplitedDateTime[1].replace(/(..)/g, '$1:').slice(0, -1);
                        arrBestFiveData[BEST5_INDEX.LAST_UPDATED_TIME] = arrSplitedDateTime[0] + ' ' + strTime;
                        break;
                    }
                    case BCAST_MSG_CODE.OPEN_INTEREST: {
                        arrBestFiveData[BEST5_INDEX.OPEN_INTEREST] = parseInt(objBestFive[1]);
                        break;
                    }
                    case BCAST_MSG_CODE.OPEN_INTEREST_PERCENT: {
                        arrBestFiveData[BEST5_INDEX.OPEN_INTEREST_PERCENT] = objBestFive[1];
                        break;
                    }
                    // case BCAST_MSG_CODE.NET_CHANGE_FROM_PRE_CLOSE: {
                    //     arrBestFiveData[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = objBestFive[1];
                    // const lstrMapKey = arrBestFiveData[BEST5_INDEX.SEGMENT_ID] + '_' + arrBestFiveData[BEST5_INDEX.TOKEN];
                    // const arrLastTick = objBestFiveData[lstrMapKey];
                    // if (undefined !== arrLastTick) {
                    //     if (parseFloat(objBestFive[1]) > parseFloat(arrLastTick[BEST5_INDEX.])) {
                    //         arrBestFiveData[
                    //             BEST5_INDEX.NET_CHANGE_INDICATOR
                    //         ] = 'U'; //netChangeIndicator
                    //     } else if (
                    //         parseFloat(objBestFive[1]) < parseFloat(arrLastTick[BEST5_INDEX.])
                    //     ) {
                    //         arrBestFiveData[
                    //             BEST5_INDEX.NET_CHANGE_INDICATOR
                    //         ] = 'D'; //netChangeIndicator
                    //     } else {
                    //         arrBestFiveData[
                    //             BEST5_INDEX.NET_CHANGE_INDICATOR
                    //         ] = 'S'; //netChangeIndicator
                    //     }
                    // } else {
                    //     arrBestFiveData[BEST5_INDEX.NET_CHANGE_INDICATOR] =
                    //         'S';
                    // }
                    // break;
                    // }
                    case BCAST_MSG_CODE.CLOSE_PRICE: {
                        arrBestFiveData[BEST5_INDEX.CLOSE_PRICE] = (parseFloat(objBestFive[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization


                        break;
                    }
                    case BCAST_MSG_CODE.OPEN_PRICE: {
                        arrBestFiveData[BEST5_INDEX.OPEN_PRICE] = (parseFloat(objBestFive[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                        break;
                    }
                    case BCAST_MSG_CODE.HIGH_PRICE: {
                        arrBestFiveData[BEST5_INDEX.HIGH_PRICE] = (parseFloat(objBestFive[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                        break;
                    }
                    case BCAST_MSG_CODE.LOW_PRICE: {
                        arrBestFiveData[BEST5_INDEX.LOW_PRICE] = (parseFloat(objBestFive[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                        break;
                    }
                    case BCAST_MSG_CODE.VOLUME: {
                        arrBestFiveData[BEST5_INDEX.VOLUME] = parseInt(objBestFive[1]); //as total qty traded
                        break;
                    }
                    case BCAST_MSG_CODE.AVG_TRADED_PRICE: {
                        arrBestFiveData[BEST5_INDEX.AVG_TRADED_PRICE] = (parseFloat(objBestFive[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                        break;
                    }
                    case BCAST_MSG_CODE.TOTAL_BUY_QTY: {
                        arrBestFiveData[BEST5_INDEX.TOTAL_BUY_QTY] = parseInt(objBestFive[1]);
                        break;
                    }
                    case BCAST_MSG_CODE.TOTAL_SELL_QTY: {
                        arrBestFiveData[BEST5_INDEX.TOTAL_SELL_QTY] = parseInt(objBestFive[1]);
                        break;
                    }
                    case BCAST_MSG_CODE.LIFE_TIME_HIGH: {
                        arrBestFiveData[BEST5_INDEX.LIFE_TIME_HIGH] = (parseFloat(objBestFive[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                        break;
                    }
                    case BCAST_MSG_CODE.LIFE_TIME_LOW: {
                        arrBestFiveData[BEST5_INDEX.LIFE_TIME_LOW] = (parseFloat(objBestFive[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength); //By HiralK : 09-08-2023 for price optimization
                        break;
                    }

                    case BCAST_MSG_CODE.DAILY_PRICE_RANGE: {
                        arrBestFiveData[BEST5_INDEX.DAILY_PRICE_RANGE] = objBestFive[1];
                        break;
                    }
                    case BCAST_MSG_CODE.TRADE_EXECUTION_RANGE: {
                        arrBestFiveData[BEST5_INDEX.LPPR] = objBestFive[1];
                        break;
                    }
                    case BCAST_MSG_CODE?.APP_DISABLE_CLOSE_PRICE: {
                        arrBestFiveData[BEST5_INDEX.APP_DISABLE_CLOSE_PRICE] = objBestFive[1];
                        let isAppDisableClosePriceOnOrOff = isAppDisableClosePrice();
                        if (isAppDisableClosePriceOnOrOff === 'ON' && parseFloat(objBestFive[1]) > 0) {
                            arrBestFiveData[BEST5_INDEX.CLOSE_PRICE] = (parseFloat(objBestFive[1]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
                        } else { }
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        });
        let nTopFiveBuySum = 0;
        let nTopFiveSellSum = 0;
        for (let i = BEST5_INDEX.BUY_QTY_1; i < arrBestFiveData.length && i <= BEST5_INDEX.SELL_PRICE_5; i += 3) {
            //Vaibhav Singh: Added parsefloat in case of undefined or null coming in response from arrBestFiveData[i]
            if (i <= BEST5_INDEX.BUY_QTY_5) {
                nTopFiveBuySum += parseFloat(arrBestFiveData[i]);
            }
            if (i <= BEST5_INDEX.SELL_QTY_5 && i > BEST5_INDEX.BUY_QTY_5) {
                nTopFiveSellSum += parseFloat(arrBestFiveData[i]);
            }
        }

        arrBestFiveData[BEST5_INDEX.BUY_PRICE_1] = (parseFloat(arrBestFiveData[BEST5_INDEX.BUY_PRICE_1]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
        arrBestFiveData[BEST5_INDEX.BUY_PRICE_2] = (parseFloat(arrBestFiveData[BEST5_INDEX.BUY_PRICE_2]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
        arrBestFiveData[BEST5_INDEX.BUY_PRICE_3] = (parseFloat(arrBestFiveData[BEST5_INDEX.BUY_PRICE_3]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
        arrBestFiveData[BEST5_INDEX.BUY_PRICE_4] = (parseFloat(arrBestFiveData[BEST5_INDEX.BUY_PRICE_4]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
        arrBestFiveData[BEST5_INDEX.BUY_PRICE_5] = (parseFloat(arrBestFiveData[BEST5_INDEX.BUY_PRICE_5]) / nDecimalLocator).toFixed(nDecimalLocatorLength);

        arrBestFiveData[BEST5_INDEX.SELL_PRICE_1] = (parseFloat(arrBestFiveData[BEST5_INDEX.SELL_PRICE_1]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
        arrBestFiveData[BEST5_INDEX.SELL_PRICE_2] = (parseFloat(arrBestFiveData[BEST5_INDEX.SELL_PRICE_2]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
        arrBestFiveData[BEST5_INDEX.SELL_PRICE_3] = (parseFloat(arrBestFiveData[BEST5_INDEX.SELL_PRICE_3]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
        arrBestFiveData[BEST5_INDEX.SELL_PRICE_4] = (parseFloat(arrBestFiveData[BEST5_INDEX.SELL_PRICE_4]) / nDecimalLocator).toFixed(nDecimalLocatorLength);
        arrBestFiveData[BEST5_INDEX.SELL_PRICE_5] = (parseFloat(arrBestFiveData[BEST5_INDEX.SELL_PRICE_5]) / nDecimalLocator).toFixed(nDecimalLocatorLength);

        arrBestFiveData[BEST5_INDEX.BUY_QTY_PERCENT_1] = calculateHistogram(nTopFiveBuySum, arrBestFiveData[BEST5_INDEX.BUY_QTY_1]);
        arrBestFiveData[BEST5_INDEX.BUY_QTY_PERCENT_2] = calculateHistogram(nTopFiveBuySum, arrBestFiveData[BEST5_INDEX.BUY_QTY_2]);
        arrBestFiveData[BEST5_INDEX.BUY_QTY_PERCENT_3] = calculateHistogram(nTopFiveBuySum, arrBestFiveData[BEST5_INDEX.BUY_QTY_3]);
        arrBestFiveData[BEST5_INDEX.BUY_QTY_PERCENT_4] = calculateHistogram(nTopFiveBuySum, arrBestFiveData[BEST5_INDEX.BUY_QTY_4]);
        arrBestFiveData[BEST5_INDEX.BUY_QTY_PERCENT_5] = calculateHistogram(nTopFiveBuySum, arrBestFiveData[BEST5_INDEX.BUY_QTY_5]);

        arrBestFiveData[BEST5_INDEX.SELL_QTY_PERCENT_1] = calculateHistogram(nTopFiveSellSum, arrBestFiveData[BEST5_INDEX.SELL_QTY_1]);
        arrBestFiveData[BEST5_INDEX.SELL_QTY_PERCENT_2] = calculateHistogram(nTopFiveSellSum, arrBestFiveData[BEST5_INDEX.SELL_QTY_2]);
        arrBestFiveData[BEST5_INDEX.SELL_QTY_PERCENT_3] = calculateHistogram(nTopFiveSellSum, arrBestFiveData[BEST5_INDEX.SELL_QTY_3]);
        arrBestFiveData[BEST5_INDEX.SELL_QTY_PERCENT_4] = calculateHistogram(nTopFiveSellSum, arrBestFiveData[BEST5_INDEX.SELL_QTY_4]);
        arrBestFiveData[BEST5_INDEX.SELL_QTY_PERCENT_5] = calculateHistogram(nTopFiveSellSum, arrBestFiveData[BEST5_INDEX.SELL_QTY_5]);

        const lstrMapKey = arrBestFiveData[BEST5_INDEX.SEGMENT_ID] + '_' + arrBestFiveData[BEST5_INDEX.TOKEN];
        //Vaibhav Singh: 04-03-24: Added ClosePrice as Implemented In Wave2.0 --Start
        if (parseFloat(arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE]) === 0) {
            arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE] = arrBestFiveData[BEST5_INDEX.CLOSE_PRICE];
        }
        //Vaibhav Singh: 04-03-24: Added ClosePrice as Implemented In Wave2.0 --End

        //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
        if (parseFloat(arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE]) - parseFloat(arrBestFiveData[BEST5_INDEX.CLOSE_PRICE]) > 0) {
            var strAbsNetChange = '+' + (parseFloat(arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE]) - parseFloat(arrBestFiveData[BEST5_INDEX.CLOSE_PRICE])).toFixed(nDecimalLocatorLength);
        } else {
            strAbsNetChange = (parseFloat(arrBestFiveData[BEST5_INDEX.LAST_TRADE_PRICE]) - parseFloat(arrBestFiveData[BEST5_INDEX.CLOSE_PRICE])).toFixed(nDecimalLocatorLength);
        }
        arrBestFiveData[BEST5_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] = strAbsNetChange;
        //Ameersha N : 19-04-2023 - Breeze - APP-DISABLE-CLOSE-PRICE :: FROM TOUCHLINE DATA --Start
        const netChange = parseFloat(arrBestFiveData[BEST5_INDEX.CLOSE_PRICE]) !== 0 ? (parseFloat(strAbsNetChange) / parseFloat(arrBestFiveData[BEST5_INDEX.CLOSE_PRICE])) * 100 : 0;

        arrBestFiveData[BEST5_INDEX.NET_CHANGE_FROM_PRE_CLOSE] = netChange?.toFixed(2) > 0 ? ('+' + netChange?.toFixed(2)) : netChange?.toFixed(2);
        //Ameersha N : 19-04-2023 - Breeze - APP-DISABLE-CLOSE-PRICE :: FROM TOUCHLINE DATA --End
        //Maaz A : 04-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
        if (arrBestFiveData?.length > 0 && objBestFiveData[lstrMapKey]) {
            const strBCastBuyPrice = objBestFiveData[lstrMapKey][BEST5_INDEX.BUY_PRICE_1];
            if (parseFloat(strBCastBuyPrice) > parseFloat(arrBestFiveData[BEST5_INDEX.BUY_PRICE_1])) {
                arrBestFiveData[BEST5_INDEX.BUY_PRICE_INDICATOR] = 'U';
            } else if (parseFloat(strBCastBuyPrice) < parseFloat(arrBestFiveData[BEST5_INDEX.BUY_PRICE_1])) {
                arrBestFiveData[BEST5_INDEX.BUY_PRICE_INDICATOR] = 'D';
            } else {
                arrBestFiveData[BEST5_INDEX.BUY_PRICE_INDICATOR] = 'S';
            }
        } else {
            arrBestFiveData[BEST5_INDEX.BUY_PRICE_INDICATOR] = 'S';
        }

        if (arrBestFiveData?.length > 0 && objBestFiveData[lstrMapKey]) {
            const strBCastSellPrice = objBestFiveData[lstrMapKey][BEST5_INDEX.SELL_PRICE_1];
            if (parseFloat(strBCastSellPrice) > parseFloat(arrBestFiveData[BEST5_INDEX.SELL_PRICE_1])) {
                arrBestFiveData[BEST5_INDEX.SELL_PRICE_INDICATOR] = 'U';
            } else if (parseFloat(strBCastSellPrice) < parseFloat(arrBestFiveData[BEST5_INDEX.SELL_PRICE_1])) {
                arrBestFiveData[BEST5_INDEX.SELL_PRICE_INDICATOR] = 'D';
            } else {
                arrBestFiveData[BEST5_INDEX.SELL_PRICE_INDICATOR] = 'S';
            }
        } else {
            arrBestFiveData[BEST5_INDEX.SELL_PRICE_INDICATOR] = 'S';
        }


        objBestFiveData[lstrMapKey] = JSON.parse(JSON.stringify(arrBestFiveData));
        globalReduxStore.dispatch(updateWfhBestFiveLastTick(objBestFiveData));
        const bestfiveEvent = new CustomEvent("bestfive", { detail: arrBestFiveData, bubbles: true });
        document.dispatchEvent(bestfiveEvent);
        handleBestFiveTouchline(arrBestFiveData);
    } catch (err) {
        console.log('Bestfive_ERROR', err);
    }
}

let deCompressData = function (arrPktData) {
    try {
        let arrCompData = new Uint8Array(arrPktData);
        arrCompData = arrCompData.subarray(6, arrCompData.length);
        let arrUncompData = Zlib.uncompress(new Uint8Array(arrCompData));
        let _sResp = [];
        for (let i = 0, len = arrUncompData.length; i < len; i += 1) {
            _sResp.push(String.fromCharCode(arrUncompData[i]));
        }
        return _sResp.join('');
    } catch (e) {
        console.error('deCompressData', e);
    }
};

let handleNormalData = function (arrPlainData) {
    try {
        let arrData = new Uint8Array(arrPlainData);
        let arrResp = [];
        for (let i = 0; i < arrData.length; i += 1) {
            arrResp.push(String.fromCharCode(arrData[i]));
        }
        return arrResp.join('');
    } catch (e) {
        //console.log("handleNormalData", e);
    }
};

let processSocketMessage = function (arrUncompData) {
    let strResponse;
    if (objSelfSocCom.CompressStatus === objGlobal.Constants.C_S_ON)
        strResponse = deCompressData(arrUncompData);
    else strResponse = handleNormalData(arrUncompData);

    if (strResponse === undefined) {
        //console.log(strResponse);
    }
    let nTmtrIndex = strResponse.indexOf(objGlobal.Constants.C_S_CHAR0);
    if (nTmtrIndex !== -1) {
        strResponse = strResponse.substr(0, nTmtrIndex);
    }

    let arrData = strResponse.split(objGlobal.Constants.C_S_CHAR2);
    let nDataCount = arrData.length;

    for (let nDataCntr = 0; nDataCntr < nDataCount; nDataCntr++) {
        if (arrData[nDataCntr] !== '') {
            processPacketString(arrData[nDataCntr]);
        }
    }
};

function closeSocket() {
    try {

        if (objSocket !== null) {
            updateConnectionStatus('Disconnecting websocket');
            objSocket.close();

        }
    } catch (ex) {
        updateConnectionStatus(
            'Failed to close socket. Reason : ' +
            ex.message +
            ' | Stack trace : ' +
            ex.stack,
        );
    }
}

function sendMessageOnSocket(strMsg) {
    try {
        if (objSocket.readyState === 1) {
            objSocket.send(addHTTPHeader(strMsg));
            updateConnectionStatus('Message sent on socket successfully');
            updateConnectionStatus('Message: ' + strMsg);
        } else {
            updateConnectionStatus(
                'Websocket connection not open. Ready state : ' +
                getReadyStateDesc(objSocket.readyState),
            );
        }
    } catch (ex) {
        updateConnectionStatus(
            'Error occurred while sending message on socket. Reason : ' +
            ex.message +
            ' | Stack trace : ' +
            ex.stack,
        );
    }
}

let arrBaOldData = null;

let onSocketDataReceive = function (event) {
    try {
        let nRawPktLen;
        let bIsBroken = false;
        let nTotalPacketLength = 0;

        if (event.data instanceof ArrayBuffer) {
            let arrDataReceived = null;
            let dataPacketLengthList = [];
            if (arrBaOldData === null) arrDataReceived = new Uint8Array(event.data);
            else {
                arrDataReceived = appendOrCopyBuffer(arrBaOldData, event.data);
                arrBaOldData = null;
            }

            nRawPktLen = arrDataReceived.byteLength;
            let i = 0;
            if (nRawPktLen > 5) {
                while (i < nRawPktLen) {
                    if (arrDataReceived[i] === 5 || arrDataReceived[i] === 2) {
                        let strPacketLength = String.fromCharCode.apply(
                            null,
                            arrDataReceived.subarray(i + 1, i + 6),
                        );
                        if (strPacketLength.length === 5) {
                            let packetLength = parseInt(strPacketLength, 10);
                            dataPacketLengthList.push(packetLength + 6);
                            nTotalPacketLength += packetLength + 6;
                            i = i + 6 + packetLength;
                        } else {
                            arrBaOldData = arrDataReceived.subarray(i, nRawPktLen);
                            bIsBroken = true;
                            break;
                        }
                    }
                    // else alert();
                }
            } else arrBaOldData = arrDataReceived;

            if (nRawPktLen === nTotalPacketLength) {
                for (
                    let i = 0,
                    j = 0,
                    k = dataPacketLengthList[0],
                    len = dataPacketLengthList.length;
                    i < len;
                    i++
                ) {
                    let arrUncompData = arrDataReceived.subarray(j, k);
                    processSocketMessage(arrUncompData);


                    j = k;
                    k = k + dataPacketLengthList[i + 1];
                }
                arrBaOldData = null;
            } else {
                let i = 0,
                    j = 0;
                let k = dataPacketLengthList.length > 0 ? dataPacketLengthList[0] : 0;

                if (!bIsBroken) {
                    for (let len = dataPacketLengthList.length; i < len - 1; i++) {
                        let arrUncompData = arrDataReceived.subarray(j, k);
                        processSocketMessage(arrUncompData);

                        j = k;
                        k = k + dataPacketLengthList[i + 1];
                    }

                    if (i === dataPacketLengthList.length - 1) {
                        if (arrDataReceived.subarray(j, k)[0] !== 5) alert();

                        arrBaOldData = null;
                        arrBaOldData = arrDataReceived.subarray(j, k);
                        if (arrBaOldData[0] !== 5 && arrBaOldData[0] !== 2) alert();
                    } else alert();
                } else {
                    for (let len = dataPacketLengthList.length; i < len; i++) {
                        let arrUncompData = arrDataReceived.subarray(j, k);
                        processSocketMessage(arrUncompData);

                        j = k;
                        k = k + dataPacketLengthList[i + 1];
                    }
                    bIsBroken = false;
                }
            }
        } else {
            processPacketString(event.data);
        }
    } catch (e) {
        console.error('onSocketDataReceive ->', e);
    }
};

let socketOnMessage = function (msg) {
    try {
        updateServerReceivedMessage('Data received from server');
        onSocketDataReceive(msg);
    } catch (ex) {
        //console.log("socketOnMessage err =>", ex);
    }
};

let socketOnOpen = function () {
    try {
        updateConnectionStatus(
            'Websocket Event Open Successfully. Ready state : ' +
            getReadyStateDesc(objSocket.readyState),
        );
        let strActiveSession = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
        if (strActiveSession) {
            let objActiveSession = JSON.parse(strActiveSession);
            var strUsedId = objActiveSession?.data?.user_id;
        }

        let strLoginRequest =
            '63=FT3.0|64=101|65=74|66=14:38:22|67=' +
            strUsedId +
            '|68=|4=|400=0|396=HO|51=4|395=127.0.0.1';
        sendMessageOnSocket(strLoginRequest);
    } catch (error) {
        //console.log("socketOnOpen ->", error);
    }
};

let socketOnClose = function (event) {
    try {
        //Shuaib P : 21-02-2024  Handle Reconnection --Start
        ReconnectSocket();
        //Shuaib P : 21-02-2024  Handle Reconnection --End
        let strReason;
        if (event.code === 1000)
            strReason =
                'Normal closure, meaning that the purpose for which the connection was established has been fulfilled.';
        else if (event.code === 1001)
            strReason =
                'An endpoint is "going away", such as a server going down or a browser having navigated away from a page.';
        else if (event.code === 1002)
            strReason =
                'An endpoint is terminating the connection due to a protocol error';
        else if (event.code === 1003)
            strReason =
                'An endpoint is terminating the connection because it has received a type of data it cannot accept (e.g., an endpoint that understands only text data MAY send this if it receives a binary message).';
        else if (event.code === 1004)
            strReason =
                'Reserved. The specific meaning might be defined in the future.';
        else if (event.code === 1005)
            strReason = 'No status code was actually present.';
        else if (event.code === 1006)
            strReason =
                'The connection was closed abnormally, e.g., without sending or receiving a Close control frame';
        else if (event.code === 1007)
            strReason =
                'An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).';
        else if (event.code === 1008)
            strReason =
                'An endpoint is terminating the connection because it has received a message that "violates its policy". This reason is given either if there is no other suitable reason, or if there is a need to hide specific details about the policy.';
        else if (event.code === 1009)
            strReason =
                'An endpoint is terminating the connection because it has received a message that is too big for it to process.';
        else if (event.code === 1010)
            strReason =
                "An endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake. <br /> Specifically, the extensions that are needed are: " +
                event.reason;
        else if (event.code === 1011)
            strReason =
                'A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.';
        else if (event.code === 1015)
            strReason =
                "The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).";
        else strReason = 'Unknown strR';

        updateConnectionStatus(
            'Websocket Event Close Called. Code : ' +
            event.code +
            ', Reason : ' +
            strReason,
        );
    } catch (ex) {
        updateConnectionStatus(
            'Failed in close event. Reason : ' +
            ex.message +
            ' | Stack trace : ' +
            ex.stack,
        );
    }
};

let socketOnError = function (error) {
    updateConnectionStatus(
        'Websocket Event OnError Called. Ready State : ' +
        getReadyStateDesc(objSocket.readyState),
    );
};





function connectSocket(wfhConnectionString) {
    try {
        if (objSocket?.readyState === 1 || objSocket?.readyState === 0) {
            updateConnectionStatus('Connection already established!');
        } else {
            if (!wfhConnectionString) {
                let strActiveSession = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.USER_ACTIVE_SESSION);
                if (strActiveSession) {
                    let objActiveSession = JSON.parse(strActiveSession);
                    wfhConnectionString = objActiveSession?.data?.others?.broadCastSocket;
                } else { }
            } else { }
            objSocket = null;
            updateConnectionStatus(
                'Conecting web socket to server[' + wfhConnectionString + ']',
            );
            objSocket = new WebSocket(wfhConnectionString);
            objSocket.binaryType = 'arraybuffer';
            objSocket.onopen = socketOnOpen;
            objSocket.onclose = socketOnClose;
            objSocket.onerror = socketOnError;
            objSocket.onmessage = socketOnMessage;
            updateConnectionStatus('Opening websocket . . .');
        }
    } catch (err) {
        updateConnectionStatus(
            'Failed to connect to server. Reason : ' +
            err.message +
            ' | Stack trace : ' +
            err.stack,
        );
    }
}
//Vaibhav Singh: 23-02-24: Implemented BatchWise touchline Request: Start
function sendTouchlineRequestInBatches(arrScrips) {
    try {
        if (objSocket?.readyState === 1) {
            arrScrips?.forEach((arrBatchScrips) => {
                let strSubs = "";
                let strUnSubs = "";
                arrBatchScrips?.forEach((data) => {
                    // ---BT-113521_SrikanthRao_17-07-2023_FilterExchanges-Start
                    // let bExchangesExist = bExchahangesAllowed(data.exchangeId);
                    //As per discuss with Om allowed exchange functionality removed as sync with wave ----Azeem K 17-10-2023
                    // if (bExchangesExist) {
                    if (data.isSubscribe === false) {
                        if (`${data.exchangeId}_${data.token}` in objTokenWiseTLSubscripionCounter) {

                            objTokenWiseTLSubscripionCounter[`${data.exchangeId}_${data.token}`] -= 1;

                            if (objTokenWiseTLSubscripionCounter[`${data.exchangeId}_${data.token}`] <= 0) {
                                strUnSubs += `${data.exchangeId}_${data.token},`;
                                delete objTokenWiseTLSubscripionCounter[`${data.exchangeId}_${data.token}`];
                            } else { }
                        } else {
                            strUnSubs += `${data.exchangeId}_${data.token},`;
                            delete objTokenWiseTLSubscripionCounter[`${data.exchangeId}_${data.token}`]; // Not Required but for any unusual case handling
                        }
                    } else {
                        if (`${data.exchangeId}_${data.token}` in objTokenWiseTLSubscripionCounter) {
                            if (objTokenWiseTLSubscripionCounter[`${data.exchangeId}_${data.token}`] === 0) {
                                strSubs += `${data.exchangeId}_${data.token},`;
                            } else { }
                            objTokenWiseTLSubscripionCounter[`${data.exchangeId}_${data.token}`] += 1;
                        } else {
                            strSubs += `${data.exchangeId}_${data.token},`;
                            objTokenWiseTLSubscripionCounter[`${data.exchangeId}_${data.token}`] = 1;
                        }
                    }
                    // } else {}
                });
                // ---BT-113521_SrikanthRao_17-07-2023_2023_FilterExchanges-end
                strSubs = strSubs.slice(0, -1);
                strUnSubs = strUnSubs.slice(0, -1);
                // If both are blank dont send request to WFH
                if (strSubs || strUnSubs) {
                    isSubscribeUnSubscribeHandler('TL', strSubs, strUnSubs);
                } else { }
            });
        }

    } catch (error) {
        console.error("sendTouchlineRequest->", error);
    }
}

function sendTouchlineRequest(arrScrips) {
    try {
        let appInfo = globalReduxStore.getState();
        let batch_size_appInfo = getAppInfoData('APP_SCRIPS_BATCH_COUNT', appInfo?.appInfo?.appInfo);
        let batch_size = batch_size_appInfo ? batch_size_appInfo : 15;
        let chunks = [];

        globalReduxStore.dispatch(updateTouchlineObj({ ...objTokenWiseTLSubscripionCounter }));
        if (arrScrips?.length > batch_size) {
            for (let i = 0; i < arrScrips?.length; i += batch_size) {
                const chunk = arrScrips?.slice(i, i + batch_size);
                chunks.push(chunk);
            }
            sendTouchlineRequestInBatches(chunks);
        } else {
            sendTouchlineRequestInBatches([arrScrips]);
        }
    } catch (error) {
        console.error("sendTouchlineRequest->", error);
    }
}
//Vaibhav Singh: 23-02-24: Implemented BatchWise touchline Request: End
function sendBestFiveRequest(objScrips) {
    try {
        let strSubs = '';
        let strUnSubs = '';
        // let bExchangesExist = bExchahangesAllowed(objScrips.exchangeId);
        // ---BT-113521_SrikanthRao_17-07-2023_FilterExchanges-Start
        //As per discuss with Om allowed exchange functionality removed as sync with wave ----Azeem K 17-10-2023
        // if (bExchangesExist) {
        globalReduxStore.dispatch(updateBestFiveObj({ ...objTokenWiseB5SubscripionCounter }));

        if (objScrips.isSubscribe === false) {
            if (`${objScrips.exchangeId}_${objScrips.token}` in objTokenWiseB5SubscripionCounter) {

                objTokenWiseB5SubscripionCounter[`${objScrips.exchangeId}_${objScrips.token}`] -= 1;

                if (objTokenWiseB5SubscripionCounter[`${objScrips.exchangeId}_${objScrips.token}`] <= 0) {
                    strUnSubs += `${objScrips.exchangeId}_${objScrips.token},`;
                    delete objTokenWiseB5SubscripionCounter[`${objScrips.exchangeId}_${objScrips.token}`];
                } else { }
            } else {
                strUnSubs += `${objScrips.exchangeId}_${objScrips.token},`;
                delete objTokenWiseB5SubscripionCounter[`${objScrips.exchangeId}_${objScrips.token}`]; // Not Required but for any unusual case handling
            }
        } else {
            if (`${objScrips.exchangeId}_${objScrips.token}` in objTokenWiseB5SubscripionCounter) {
                if (objTokenWiseB5SubscripionCounter[`${objScrips.exchangeId}_${objScrips.token}`] === 0) {
                    strSubs += `${objScrips.exchangeId}_${objScrips.token},`;
                } else { }
                objTokenWiseB5SubscripionCounter[`${objScrips.exchangeId}_${objScrips.token}`] += 1;
            } else {
                strSubs += `${objScrips.exchangeId}_${objScrips.token},`;
                objTokenWiseB5SubscripionCounter[`${objScrips.exchangeId}_${objScrips.token}`] = 1;
            }
        }
        // } else {}
        // ---BT-113521_SrikanthRao_17-07-2023_FilterExchanges-end
        strSubs = strSubs.slice(0, -1);
        strUnSubs = strUnSubs.slice(0, -1);
        // If both are blank dont send request to WFH
        if (strSubs || strUnSubs) {
            isSubscribeUnSubscribeHandler('B5', strSubs, strUnSubs);
        } else { }
    } catch (error) {
        console.error("sendBestFiveRequest->", error);
    }
}

function isSubscribeUnSubscribeHandler(
    strType,
    strSubscibeStocks,
    strUnSubscibeStocks,
) {
    if (!strUnSubscibeStocks) {
        sendSubscription(strType, strSubscibeStocks, true);
    } else {
        sendSubscription(strType, strUnSubscibeStocks, false);
        if (strSubscibeStocks) {
            sendSubscription(strType, strSubscibeStocks, true);
        } else { }
    }
}

function sendSubscription(strType, strStocks, bIsSubscribe) {
    try {
        let strMsg = '',
            strMsgToSend = '';
        if (strType === 'TL') {
            strMsg = strStocks;
            let arrToken = strMsg.split(',');
            strMsgToSend = '63=FT3.0|64=206|65=84|66=19:02:31|4=|';
            for (let i = 0; i < arrToken.length && strMsg !== ''; i++) {
                strMsgToSend +=
                    '1=' +
                    arrToken[i].split('_')[0] +
                    '$7=' +
                    arrToken[i].split('_')[1] +
                    '|';
            }
            if (bIsSubscribe) {
                strMsgToSend += '230=1';
            } else {
                strMsgToSend += '230=2';
            }
        } else if (strType === 'B5') {
            strMsg = strStocks;
            strMsgToSend =
                '63=FT3.0|64=127|65=84|66=19:02:31|4=|1=' +
                strMsg.split('_')[0] +
                '|7=' +
                strMsg.split('_')[1] +
                '|';
            if (bIsSubscribe) {
                strMsgToSend += '230=1';
            } else {
                strMsgToSend += '230=2';
            }
        }
        sendMessageOnSocket(strMsgToSend);
    } catch (ex) {
        updateConnectionStatus(
            'Error occurred while sending message on socket. Reason : ' +
            ex.message +
            ' | Stack trace : ' +
            ex.stack,
        );
    }
}

export {
    connectSocket,
    sendTouchlineRequest,
    sendBestFiveRequest,
    isSubscribeUnSubscribeHandler,
    sendSubscription,
    closeSocket,
    objTouchlineData,
};